/* eslint-disable no-use-before-define,no-throw-literal,react-hooks/exhaustive-deps */
import React from 'react'
import { getConfig, getBrand, FrameIn, setBackFrom, trackPage, getState } from '../../twd'

const state = getState('tols.bond_details', {
    url: '',
})

export default ({cusip, url, showBackLink, from=''} = {}) => {

    const [url_, setUrl_] = React.useState(state.value.url || url)
    trackPage('tools.bond-detail')

    React.useEffect(() => {

        if (!cusip) return
        let sp = new URLSearchParams()
        sp.set('p_cusip', cusip)
        sp.set('p_id_type', 'I')
        sp.set('p_actn', '')
        sp.set('p_showBackLink', showBackLink==='N' ? 'N' : 'Y')
        sp.set('p_ask_id', '')
        sp.set('p_bid_id', '')
        sp.set('p_ts', Date.now())

        let base = getConfig('bw_service_host') + '/' + getBrand()
        let url = `${base}/servlet/issuedesc/issuedesc.htm?${sp.toString()}`
        setUrl_(url)

        if (from) setBackFrom('tools.bond-detail', from)
    }, [cusip])


    if (!url_ && !cusip) {
        throw new Error("tools.bond-detail: missing cusip")
    }

    if (!url_) return null

    return <React.Fragment>
        <FrameIn dataName="tools-bond-details-frame" src={url_} />
    </React.Fragment>
}


